import React, { Component } from 'react';
import {
  Form,
  Input,
  Label,
  Button,
} from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Opinions extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="Opinions">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Opinions__Form"
        >
          <h1>{translate('fiche.opinions.title')}</h1>

          <Label text={translate('fiche.opinions.training')} />
          <Input
            name="training"
            defaultValue={data.training}
          />

          <Label text={translate('fiche.opinions.nutrition')} />
          <Input
            name="nutrition"
            defaultValue={data.nutrition}
          />

          <Label text={translate('fiche.opinions.vaccinations')} />
          <Input
            name="vaccinations"
            defaultValue={data.vaccinations}
          />

          <Label text={translate('fiche.opinions.others')} />
          <Input
            name="others"
            defaultValue={data.others}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Opinions);
